<template>
    <th class="table-th border-style" @click="onHeaderClicked">
        {{ title }}
    </th>
</template>

<script>
export default {
    name: "TagTableHeader",
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    methods: {
        onHeaderClicked() {
            this.$emit('click-header')
        }
    },
}
</script>

<style scoped>
.table-th{
    font-size: 11px;
    padding-right: 8px;
}
.border-style{
    border: 1px solid #6f6f6f;
}
</style>